module.exports = __webpack_public_path__ + "img/teacher-answer-bg_new.37962a4d.png";